// @ag-grid-community/react v27.3.0
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
exports.BeansContext = react_1.default.createContext({});

//# sourceMappingURL=beansContext.js.map
